import React from 'react';
import "../../styles/collections/no_collections.css";
import noCollectionsImage from "../../images/collections/no_collection.png"
import AddCollection from "./add_collection";
import { useState } from "react";

const NoCollections = () => {
    const [isShow, setShow] = useState(false);

    const onAdd = () => {
        setShow(true);
    };

    return(
        <div className="no_collection_available">
            <img alt='no collection' src={noCollectionsImage} className="no_collection_available_img" />
            <p className="no_collections_header">Collections</p>
            <p className="no_collections_text">Your collections will appear here.</p>
            <p className="no_collections_link" onClick={() => onAdd()}>Add a new collection</p>
            {isShow && <AddCollection getShow={isShow} setShow={setShow} />}
        </div>
    );
};

export default NoCollections;